const pruebaGratuitaCovid19 = [{
		path: '/muestras/prueba_gratis',
		name: 'pruebaGratis',
		meta: {
			layout: 'blank',
		},
		component: () => import('@/views/muestras/pruebaGratuita/PruebaGratuita.vue'),
	}
]
export default pruebaGratuitaCovid19;